import 'mmenu-js';
// const langSwitch = document.querySelector('.js-lang-switcher');

const options = {

    offCanvas: {
        "use": true,
        "position": "right-front",
    },
    "theme": "dark",
    // "navbars": [
    //     {
    //         "position": "bottom",
    //         "content": [
    //             langSwitch
    //         ]
    //     }
    // ]
};

const config = {
	offCanvas: {
        clone: true, // Currently does not work with mm-burger: https://github.com/FrDH/mmenu-js/issues/1313
		page: {
			selector: '#page'
		}
	},
    classNames: {
        // This ensures that the menu shows the correct level,
        // when opening the menu on a child-page.
        selected: 'current'
    }
};

export default function initMenu() {
	const menu = new Mmenu('#menu', options, config);
    const api = menu.API;

    const open = document.querySelector('#mmenu-open');
    if (!open) return;
    open.addEventListener('click', (event) => {
        event.preventDefault();
        api.open();
    });
}
